import { Device, Message } from './types';

export class FileSpreadDB {
  private pinnedDevices: Map<string, Device> = new Map();
  private messages: Map<string, Message> = new Map();

  async init(): Promise<void> {
    return Promise.resolve();
  }

  async getPinnedDevices(): Promise<Device[]> {
    return Promise.resolve(Array.from(this.pinnedDevices.values()));
  }

  async pinDevice(device: Device): Promise<void> {
    this.pinnedDevices.set(device.id, { ...device, isPinned: true });
    return Promise.resolve();
  }

  async unpinDevice(deviceId: string): Promise<void> {
    this.pinnedDevices.delete(deviceId);
    return Promise.resolve();
  }

  async saveMessage(message: Message): Promise<void> {
    const { fileData, ...meta } = message;
    this.messages.set(message.id, meta as Message);
    return Promise.resolve();
  }

  async deleteMessage(messageId: string): Promise<void> {
    this.messages.delete(messageId);
    return Promise.resolve();
  }

  async getMessages(peerId: string): Promise<Message[]> {
    const all = Array.from(this.messages.values());
    const filtered = all
      .filter(m => m.senderId === peerId || m.receiverId === peerId)
      .sort((a, b) => a.timestamp - b.timestamp);
    return Promise.resolve(filtered);
  }

  async deleteChat(peerId: string): Promise<void> {
    const all = Array.from(this.messages.values());
    const toDelete = all.filter(m => m.senderId === peerId || m.receiverId === peerId);
    for (const msg of toDelete) {
      this.messages.delete(msg.id);
    }
    return Promise.resolve();
  }
}

export const db = new FileSpreadDB();
